import React from 'react';
import PropTypes from 'prop-types';
import Message from 'components/Message';
import messages from '../../ScheduleForm.messages';
import './isNoEndDate.scss';

const IsNoEndDate = ({ input: { value, onChange } }) => (
  <div className="no-end-date">
    <input
      type="checkbox"
      onChange={event => onChange(event)}
      checked={value}
      id="no-end-date-checkbox"
      className="no-end-date__checkbox"
    />
    <Message message={messages.inputs.isNoEndDate.noEndDate} />
  </div>
);

IsNoEndDate.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onChange: PropTypes.func,
  }),
};

export default IsNoEndDate;
